import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

/**
 * Interceptor to prevent browser caching of GET requests.
 * Adds Cache-Control headers to ensure fresh data is always fetched.
 * Skips cross-origin requests to avoid CORS preflight issues.
 */
export const noCacheInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (req.method === 'GET' && isSameOriginOrRelative(req.url)) {
    const noCacheReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      }
    });
    return next(noCacheReq);
  }
  return next(req);
};

function isSameOriginOrRelative(url: string): boolean {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return true;
  }
  try {
    const requestUrl = new URL(url);
    return requestUrl.origin === globalThis.location?.origin;
  } catch {
    return true;
  }
}
